module.exports = __webpack_public_path__ + "img/free-shipping.e011e225.svg";